export default __webpack_public_path__ + "static/media/p2.6289afa1.jpg";